@if (VendorId || ExemptVendorId || ClientRegisteredVendorId) {
  <div class="container-fluid h-100 d-flex flex-column admin-vendor-page">
    <div class="row">
      <div class="col">
        <h2 class="admin-vendor-page__title">{{ title }}</h2>
      </div>
    </div>
    <div class="row component-container">
      <div class="col g-0">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
}
